import React, { useState } from 'react'
import { setItem } from '../../../global/data/synch-storage.js'
import { getRelativeBasePath } from '../../../global/environments/path.js'
import {
  CHANGE_PASSWORD_SUCCESS,
  FORM_NAME_CHALLENGE_CHOICE,
  FORM_NAME_CHALLENGE_QUESTION,
  FORM_NAME_CHANGE_PASSWORD,
  FORM_NAME_CONTACT_REPRESENTATIVE,
  FORM_NAME_LOGIN_FORM,
  FORM_NAME_ONE_TIME_PASSCODE,
  FORM_NAME_USER_ID,
  MFA_ANSWERED,
  PASSWORD_MODE,
} from '../../Login/Helpers/LoginHelper.js'
import ChallengeChoice from '../../Login/Modules/ChallengeChoice.jsx'
import ChallengeQuestion from '../../Login/Modules/ChallengeQuestion.jsx'
import ChangePassword from '../../Login/Modules/ChangePassword.jsx'
import OneTimePasscode from '../../Login/Modules/OneTimePasscode.jsx'
import { useUserIdHook } from './Hooks/UserIdHook.js'
import UserIdForm from './Modules/UserIdForm.jsx'

function ForgotPassword() {
  const userIdHook = useUserIdHook()
  const [displayForm, setDisplayForm] = useState(FORM_NAME_USER_ID)
  const [mfaData, setMfaData] = useState(null)
  const [otpDta, setOtpData] = useState(null)
  const [challengeQuestionData, setChallengeQuestionData] = useState(null)
  const [phoneNbr, setPhoneNbr] = useState(null)
  /* eslint no-unused-vars: 'warn' */
  const [changePasswordData, setChangePasswordData] = useState(null)

  const handleDisplayChange = (display, data) => {
    if (display === FORM_NAME_USER_ID || display === FORM_NAME_LOGIN_FORM) {
      setDisplayForm(FORM_NAME_USER_ID)
    }

    if (display === FORM_NAME_CHALLENGE_CHOICE) {
      setDisplayForm(display)
      if (data) {
        let routes = data.value?.routes?.value || data?.value?.routes || []
        let lastFourDigits =
          routes
            .find((route) => route.channel === 'SMS' || route.channel === 'IVR')
            ?.route?.slice(-4) || ''
        setMfaData(data)
        setPhoneNbr(lastFourDigits)
      }
    }

    if (display === FORM_NAME_CONTACT_REPRESENTATIVE) {
      setDisplayForm(display)
    }

    if (display === FORM_NAME_ONE_TIME_PASSCODE) {
      setDisplayForm(display)
      setOtpData(data)
    }

    if (display === FORM_NAME_CHALLENGE_QUESTION) {
      setDisplayForm(display)
      setChallengeQuestionData(data)
    }

    if (display === MFA_ANSWERED) {
      if (data.response) {
        const apiToken = data.response.headers.get('apitoken')
        setItem('apiToken', apiToken)
      }
      setDisplayForm(FORM_NAME_CHANGE_PASSWORD)
    }

    if (display === CHANGE_PASSWORD_SUCCESS) {
      window.location.href =
        getRelativeBasePath() + '/login?forgotPassword=true'
    }
  }

  return (
    <div className="u-bgColorLightest u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft0 u-borderRight0 u-padding8gu u-marginBottom10gu">
      <div className="u-sizeConstrained">
        {displayForm === FORM_NAME_USER_ID && (
          <UserIdForm
            handleDisplayChange={handleDisplayChange}
            userIdHook={userIdHook}
          />
        )}
        {displayForm === FORM_NAME_CHALLENGE_CHOICE && (
          <ChallengeChoice
            handleDisplayChange={handleDisplayChange}
            mfaResponseData={mfaData}
            showNewUser={false}
            phoneNumber={phoneNbr}
            mode={'fyp'}
          />
        )}
        {displayForm === FORM_NAME_CHALLENGE_QUESTION && (
          <ChallengeQuestion
            handleDisplayChange={handleDisplayChange}
            challengeQuestionData={challengeQuestionData}
            showNewUser={false}
          />
        )}
        {displayForm === FORM_NAME_ONE_TIME_PASSCODE && (
          <OneTimePasscode
            handleDisplayChange={handleDisplayChange}
            mode="fyp"
            otpData={otpDta}
            loginInputHook={userIdHook}
            phoneNumber={phoneNbr}
          />
        )}
        {displayForm === FORM_NAME_CHANGE_PASSWORD && (
          <ChangePassword
            handleDisplayChange={handleDisplayChange}
            changePasswordData={changePasswordData}
            passwordMode={PASSWORD_MODE.FORGOT_PASSWORD_CHANGE}
            loginInputHook={userIdHook}
            showNewUser={false}
          />
        )}
        {displayForm === FORM_NAME_CONTACT_REPRESENTATIVE && (
          <div className="u-sizeFull u-lg-size5of12 u-lg-after1of12 u-marginBottom6gu u-lg-marginBottom0 Content">
            <h2 className="u-marginBottom2gu u-marginTop0">
              Help us keep your account more secure
            </h2>
            <p>
              Contact a Columbia Threadneedle representative at{' '}
              <a aria-label="800. 2 4 8. 2 8 2 8" href="tel: 8002482828">
                800.248.2828
              </a>{' '}
              to proceed further.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

ForgotPassword.propTypes = {}

export default ForgotPassword
